import Select from "react-select"
import { StateManagerProps } from "react-select/dist/declarations/src/useStateManager"
import { useTheme } from "styled-components"

export default function SelectComp(props: StateManagerProps) {
  const theme = useTheme()
  return (
    <Select
      className="kg-select"
      styles={{
        control: (base, state) => ({
          ...base,
          height: "44px",
          minHeight: "44px",
          border: state.isFocused
            ? `1px solid ${theme.colors.textFamily.lightGray}`
            : "1px solid transparent",
          boxShadow: "none",
          ":hover": {
            border: `1px solid ${theme.colors.textFamily.lightGray}`
          }
        }),
        valueContainer: (base, state) => ({
          ...base,
          padding: "0px 6px"
        }),
        input: base => ({
          ...base,
          margin: 0,
          padding: 0,
          background: "transparent"
        }),
        option: (provided, state) => ({
          ...provided,
          color: theme.colors.textFamily.gray,
          ":active": {
            backgroundColor: theme.colors.primary
          },
          ":hover": {
            backgroundColor: theme.colors.primary
          },
          backgroundColor: state.isSelected
            ? theme.colors.backgroundFamily.L2
            : theme.colors.backgroundFamily.light
        })
      }}
      components={{
        IndicatorSeparator: () => null
      }}
      {...props}
    />
  )
}
